module.exports = __webpack_public_path__ + "static/media/thumb.8355818e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-threshing-barn/thumb.jpg
// module id = 45
// module chunks = 0